import React from 'react';
import { useViewport } from '@/src/app/hooks';
import mathToolsIcon from '@/src/assets/img/icons/Math-Tools.png';

const MathToolsButton: React.FC = () => {
    const { isMobile } = useViewport();

    if (isMobile) return null;

    return (
        <a
            href="https://mathtools.paradigmmath.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Math Tools"
            style={{
                position: 'fixed',
                top: '30px',
                right: '16px',
                backgroundColor: '#053E68',
                borderRadius: '50%',
                width: '48px',
                height: '48px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
                textDecoration: 'none',
                boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                zIndex: 9999,
                transition: 'transform 0.2s ease',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
            onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        >
            <div
                style={{
                    border: '1.5px solid white',
                    borderRadius: '50%',
                    width: '42px',
                    height: '42px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <img
                    src={mathToolsIcon}
                    alt="Math Tools"
                    style={{ width: '28px', height: '28px' }}
                />
            </div>
        </a>
    );
};

export default MathToolsButton;
